module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', {
    staticClass: "demo-container",
    attrs: {
      "gutter": 20
    }
  }, [_c('vCol', {
    attrs: {
      "span": "24"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('vCol', {
    ref: "left",
    attrs: {
      "span": "12"
    }
  }, [_vm._t("left")], 2), _vm._v(" "), _c('vCol', {
    attrs: {
      "rref": "right",
      "span": "12"
    }
  }, [_vm._t("right")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e7d50c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/demo.vue
// module id = 650
// module chunks = 0